import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Pages
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Resellers from './pages/Resellers';
import ResellerMerchants from './pages/ResellerMerchants';
import Customers from './pages/Customers';
import Branches from './pages/Branches';
import Plans from './pages/Plans';
import Products from './pages/Products';
import POS from './pages/POS';
import Settings from './pages/Settings';
import MyProfile from './pages/MyProfile';
import ChangePassword from './pages/ChangePassword';
import News from './pages/News';
import HowToUse from './pages/HowToUse';

function App() {
  return (
    <AuthProvider>
            <GoogleReCaptchaProvider reCaptchaKey="6LcPaF4sAAAAALeckGjx2dxjCdq3wxQXB2ca55WB">

      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/resellers"
            element={
              <PrivateRoute roles={['superadmin']}>
                <Layout>
                  <Resellers />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/resellers/:id/merchants"
            element={
              <PrivateRoute roles={['superadmin']}>
                <Layout>
                  <ResellerMerchants />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/customers"
            element={
              <PrivateRoute roles={['reseller']}>
                <Layout>
                  <Customers />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/branches"
            element={
              <PrivateRoute roles={['customer']}>
                <Layout>
                  <Branches />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/plans"
            element={
              <PrivateRoute roles={['reseller']}>
                <Layout>
                  <Plans />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/news"
            element={
              <PrivateRoute roles={['reseller']}>
                <Layout>
                  <News />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/how-to-use"
            element={
              <PrivateRoute roles={['reseller']}>
                <Layout>
                  <HowToUse />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/products"
            element={
              <PrivateRoute roles={['branch_manager', 'cashier', 'staff']}>
                <Layout>
                  <Products />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/pos"
            element={
              <PrivateRoute roles={['branch_manager', 'cashier']}>
                <Layout>
                  <POS />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Layout>
                  <Settings />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Layout>
                  <MyProfile />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/change-password"
            element={
              <PrivateRoute>
                <Layout>
                  <ChangePassword />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
      </GoogleReCaptchaProvider>
    </AuthProvider>
  );
}

export default App;
